<template>
  <div>
    <el-drawer
      :append-to-body="true"
      :wrapper-closable="false"
      :visible.sync="rangeInfoDialogVisible"
      :title="codeTitle"
      direction="ltr"
      size="60%"
      @close="clearForm"
    >
      <div style="margin: 0 10px 10px 10px">
        <el-form
          v-if="!isModify"
          :model="searchForm"
          label-position="top"
          class="searchCodeClass"
        >
          <el-row type="flex" justify="left" style="flex-wrap: wrap;align-items: end">
            <el-col :span="4">
              <el-form-item :label="$t('collectionCenter.Zip')">
                <el-input
                  v-model.trim="searchForm.params.zipCode"
                  size="small" clearable style="width: 95%"
                  :placeholder="$t('collectionCenter.pleaseInput')"
                  @input="zipCodeValueChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('collectionCenter.state')">
                <el-select
                  v-model="searchForm.params.states"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable filterable multiple
                  collapse-tags
                  size="small" style="width: 95%"
                  @change="getAddressCity(searchForm.params.states, 1)"
                >
                  <el-option
                    v-for="item in StateList"
                    :key="item.id"
                    :label="item.label"
                    :value="item.label"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('collectionCenter.city')">
                <el-select
                  v-model="searchForm.params.cities"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable filterable multiple
                  size="small" style="width: 95%"
                  remote reserve-keyword
                  :remote-method="(val) => getCity(val, 1)"
                  @clear="getAddressCity(searchForm.params.states, 1)"
                >
                  <el-option
                    v-for="(item, idx) in cityList"
                    :key="idx"
                    :label="item.name"
                    :value="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-button size="small" type="primary" @click="searchCode">
                {{ $t('collectionCenter.search') }}
              </el-button>
              <el-button size="small" style="margin-bottom: 6px" @click="resetCode">
                {{ $t('collectionCenter.reset') }}
              </el-button>
            </el-col>
          </el-row>
        </el-form>
        <div v-if="isModify" style="text-align: left; margin-bottom: 15px">
          <el-button size="small" type="primary" @click="openAddForm">{{ $t('GlobalSetObj.append') }}</el-button>
          <el-button size="small" type="danger" @click="deleteAll">{{ $t('collectionCenter.DeleteAll') }}</el-button>
        </div>
        <el-table
          :data="tableData"
          :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
          border max-height="500px"
          style="width: 100%"
          :fit="true"
        >
          <el-table-column
            :label="$t('collectionCenter.ind')" width="80" type="index"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ (searchForm.pageNumber - 1) * searchForm.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('collectionCenter.state')" prop="zipCodeState" align="center" />
          <el-table-column :label="$t('collectionCenter.city')" prop="zipCodeCity" align="center" />
          <el-table-column :label="$t('collectionCenter.startZipCode')" prop="startZip" align="center" />
          <el-table-column :label="$t('collectionCenter.endZipCode')" prop="endZip" align="center" />
          <el-table-column
            v-if="isModify" :label="$t('collectionCenter.operation')" width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span
                style="color: #1d90ff; font-size: 14px; cursor: pointer; margin-right: 5px; display: inline-block"
                @click="editRow(scope.row,scope.$index)"
              >
                {{ $t('collectionCenter.edit') }}
              </span><!-- 编辑 -->
              <el-popconfirm
                :title="$t('collectionCenter.deleteSure')"
                @confirm="delRow(scope.$index)"
              ><!-- 确定删除吗？ -->
                <span slot="reference" style="color: #1d90ff; font-size: 14px; cursor: pointer">
                  {{ $t('collectionCenter.Delete') }}
                </span><!-- 删除 -->
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!isModify" class="right">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page.sync="searchForm.pageNumber"
            :page-sizes="[10, 20, 50, 100, 500, 1000]"
            :page-size.sync="searchForm.pageSize"
            :total="total"
            background
            style="margin: 10px 0"
            @current-change="getPage"
            @size-change="searchCode"
          />
        </div>
        <div v-if="isModify" style="text-align: right; margin: 15px 0">
          <el-button size="small" @click="clearForm">{{ $t('GlobalSetObj.Close') }}</el-button>
          <el-button size="small" type="primary" @click="saveForm">{{ $t('collectionCenter.confirm') }}</el-button>
        </div>
      </div>
    </el-drawer>
    <!--  点击添加弹出添加框  -->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :visible.sync="addCodeVisible"
      :title="addEditTitle"
      top="10vh"
      width="500px"
      @close="closeAdd"
    >
      <div class="tip01">
        {{ $t('collectionCenter.tips') }}：{{ $t('collectionCenter.startPostcodeCannotExceedEnd') }}
      </div>
      <el-form
        ref="rangeInfoFormRef"
        :model="rangeInfoForm"
        label-position="top"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              :rules="{
                required: true,
                message: $t('GlobalSetObj.pleaseChoose'),
                trigger: ['blur', 'change']
              }"
              :label="$t('collectionCenter.state')"
              prop="state"
            >
              <el-select
                v-model="rangeInfoForm.state"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable filterable
                size="small" style="width: 100%"
                @change="getAddressCity(rangeInfoForm.state, 2)"
              >
                <el-option
                  v-for="item in StateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :rules="{
                required: true,
                message: $t('GlobalSetObj.pleaseChoose'),
                trigger: ['blur', 'change']
              }"
              :label="$t('collectionCenter.city')"
              prop="city"
            >
              <ElSelectV2
                v-model="rangeInfoForm.city"
                :options="cityList2"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                filterable
                size="small"
                style="width: 100%"
                clearable
                @clear="getAddressCity(rangeInfoForm.state, 2)"
              />
              <!--              <el-select-->
              <!--                v-model="rangeInfoForm.city"-->
              <!--                :placeholder="$t('GlobalSetObj.pleaseChoose')"-->
              <!--                clearable filterable-->
              <!--                size="small" style="width: 100%"-->
              <!--                remote reserve-keyword-->
              <!--                :remote-method="(val) => getCity(val, 2)"-->
              <!--                @clear="getAddressCity(rangeInfoForm.state, 2)"-->
              <!--                @visible-change="getShowCity"-->
              <!--              >-->
              <!--                <el-option-->
              <!--                  v-for="(item, idx) in cityList2"-->
              <!--                  :key="idx"-->
              <!--                  :label="item.name"-->
              <!--                  :value="item.name"-->
              <!--                />-->
              <!--              </el-select>-->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :rules="{
                required: true,
                message: $t('placeOrder.pleaseInput'),
                trigger: ['blur', 'change']
              }"
              :label="$t('collectionCenter.addPostcode')"
              prop="zipCodeRange"
              style="width: 100%"
            >
              <el-input
                v-model.trim="rangeInfoForm.zipCodeRange"
                clearable
                :placeholder="$t('collectionCenter.postcodeFormatInstructions')"
                rows="5"
                type="textarea"
                @input="handleZipCodeValueChange"
                @blur="zipCodeFil"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div v-if="errorData && errorData.length > 0" style="color: red">
        <span>{{ $t('collectionCenter.importFailedPostcodes') }}</span><br>
        <div v-for="(item, index) in errorData" :key="index" style="margin-bottom: 5px; font-size: 14px; line-height: 16px">
          <span style="font-weight: bold">{{ index + 1 }}.</span> {{ item.errorRange }}，{{ item.errorMessage }}
          <!--
           `true` - 邮编范围完全相同，可移除
            `false` - 邮编范围部分重叠，不可移除
          -->
          <span v-if="item.canRemove">
            <el-popconfirm
              :title="$t('collectionCenter.removeSure')"
              :confirm-button-text="$t('collectionCenter.yesRm')"
              :cancel-button-text="$t('collectionCenter.noRm')"
              @confirm="remove(item)"
            >
              <span slot="reference" style="text-decoration: underline;color: #59a8fd; cursor: pointer">
                {{ $t('collectionCenter.removeFromBranch') }}
              </span>
            </el-popconfirm>
          </span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAdd">{{ $t('GlobalSetObj.Close') }}</el-button>
        <el-button type="primary" @click="addCode">{{ $t('collectionCenter.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  validateZipCodeRange
} from '@/api/finance/basicData';
import { getLgAreaListData, optionSelectZipCodeManageCity, codeQuery } from '@/api/orderApi';
import ElSelectV2 from 'el-select-v2';
export default {
  components: {
    ElSelectV2
  },
  data() {
    return {
      editingRow: null, // 记录当前正在编辑的行数据
      siteId: 0, // 作为入参
      // zipCodesToRemove: [], // 需要从原网点移除的邮编列表
      zipCodesToRemove: {
        cr: [], // 小件揽收 (Collect Range) 移除列表
        dr: [], // 小件派送 (Delivery Range) 移除列表
        bdr: [] // 大件派送 (Bulky Delivery Range) 移除列表
      },
      cityList2: [], // 新增的州为单选，城市多选，需区分
      cityList: [], // 查询的州跟城市都是多选
      StateList: [],
      tableData: [],
      total: 0,
      searchForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          siteId: 0,
          zipCode: '',
          states: [],
          cities: [],
          businessType: null
        }
      }, // 邮编查询
      addEditTitle: this.$t('collectionCenter.addPostcode'),
      addCodeVisible: false,
      // 是否格式化成巴西时间
      isTormat: false,
      rangeInfoDialogVisible: false,
      rangeInfoForm: {
        state: '',
        city: '',
        zipCodeRange: ''
      },
      codeTitle: '',
      businessType: null,
      errorData: [],
      isModify: false,
      // 列表的编辑索引
      tableListIndex: null
    };
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
  },
  methods: {
    searchCode() {
      this.searchForm.pageNumber = 1;
      this.getPage();
    },
    getPage() {
      this.searchForm.params.siteId = this.siteId;
      this.searchForm.params.businessType = this.businessType;
      codeQuery(this.searchForm).then(res => {
        if (res.code === 200) {
          this.tableData = [];
          res.data.records.forEach(item => {
            if (item.zipCodeRange) {
              const zipCodeRanges = item.zipCodeRange.split(',').map(range => range.trim());
              zipCodeRanges.forEach(range => {
                let startZip = '';
                let endZip = '';
                if (range.includes('~')) {
                  const [start, end] = range.split('~');
                  startZip = start.trim();
                  endZip = end.trim();
                } else {
                  startZip = range;
                  endZip = range;
                }
                this.tableData.push({
                  ...item,
                  startZip,
                  endZip
                });
              });
            } else {
              // 如果没有 zipCodeRange，直接添加原始项
              this.tableData.push({
                ...item,
                startZip: '',
                endZip: ''
              });
            }
          });
          this.total = this.tableData.length;
        }
      });
    },
    resetCode() {
      this.searchForm.params.zipCode = '';
      this.searchForm.params.states = [];
      this.searchForm.params.cities = [];
      this.searchCode();
    },
    /**
     * @deprecated 编辑邮编
     * @param row
     * @param index
     */
    editRow(row, index) {
      this.tableListIndex = index;
      this.addCodeVisible = true;
      this.addEditTitle = this.$t('basicData.PostalCodeDetails');
      this.rangeInfoForm = {
        state: row.zipCodeState,
        city: row.zipCodeCity,
        zipCodeRange: row.startZip === row.endZip ? row.startZip : `${row.startZip}~${row.endZip}`
      };
      this.editingRow = {
        state: row.zipCodeState || null,
        city: row.zipCodeCity || null,
        startZip: row.startZip,
        endZip: row.endZip,
        zipCodeRange: row.startZip === row.endZip ? row.startZip : `${row.startZip}~${row.endZip}`
      };
      this.getCity(null, 2);
    },
    // 新增/编辑 邮编提交验证
    addCode() {
      this.errorData = []; // 清空报错信息
      this.$refs['rangeInfoFormRef'].validate((valid) => {
        if (valid) {
          if (!this.validateZipCode(this.rangeInfoForm.zipCodeRange)) return;
          if (!this.checkDuplicateWithTableData(this.rangeInfoForm.zipCodeRange)) return;
          const formData = {
            state: this.rangeInfoForm.state,
            city: this.rangeInfoForm.city,
            zipCodeRange: this.rangeInfoForm.zipCodeRange,
            businessType: this.businessType,
            siteId: this.siteId
          };
          validateZipCodeRange(formData).then(res => {
            if (res.code === 200) {
              if (!res.data.success) {
                const errorData = res.data.errorDetails.map(item => {
                  const zipCodesToRemove = [];
                  if (item.canRemove) {
                    zipCodesToRemove.push({
                      siteId: item.occupiedSiteId,
                      zipCodeRange: item.errorRange,
                      businessType: item.businessType
                    });
                  }
                  return {
                    ...item,
                    zipCodesToRemove
                  };
                });
                this.errorData = errorData;
              } else {
                this.addCodeVisible = false;
                const zipCodeData = this.parseZipCodeRange(this.rangeInfoForm.zipCodeRange);
                const tableData = zipCodeData.map(item => ({
                  zipCodeState: this.rangeInfoForm.state,
                  zipCodeCity: this.rangeInfoForm.city,
                  startZip: item.startZip,
                  endZip: item.endZip
                }));
                if (this.editingRow) {
                  const indexToReplace = this.tableData.findIndex(row =>
                    row.zipCodeState === this.editingRow.state &&
                    row.zipCodeCity === this.editingRow.city &&
                    row.startZip === this.editingRow.startZip &&
                    row.endZip === this.editingRow.endZip
                  );
                  if (indexToReplace !== -1) {
                    // 删除原来的行
                    this.tableData.splice(indexToReplace, 1);
                    // 插入新的数据
                    this.tableData.splice(indexToReplace, 0, ...tableData);
                  }
                } else {
                  this.tableData.unshift(...tableData);
                }
              }
            }
          });
        }
      });
    },
    parseZipCodeRange(zipCodeRange) {
      if (!zipCodeRange) return [];
      const zipCodeSegments = zipCodeRange.split(',').map(item => item.trim()).filter(item => item);
      const result = [];
      zipCodeSegments.forEach(segment => {
        if (segment.includes('~')) {
          const [start, end] = segment.split('~').map(s => s.trim());
          result.push({
            startZip: start,
            endZip: end
          });
        } else {
          result.push({
            startZip: segment,
            endZip: segment
          });
        }
      });
      return result;
    },
    // 已有网点使用该邮编，点击移除记录，并且更新列表数据
    remove(item) {
      this.$message.success(this.$t('collectionCenter.removeSucTips'));
      // 根据业务类型将移除信息存储到对应数组
      if (item.businessType === 2) { // 小件揽收
        this.zipCodesToRemove.cr = [...this.zipCodesToRemove.cr, ...item.zipCodesToRemove];
      } else if (item.businessType === 3) { // 小件派送
        this.zipCodesToRemove.dr = [...this.zipCodesToRemove.dr, ...item.zipCodesToRemove];
      } else if (item.businessType === 4) { // 大件派送
        this.zipCodesToRemove.bdr = [...this.zipCodesToRemove.bdr, ...item.zipCodesToRemove];
      }
      const zipCodeRange = this.parseZipCodeRange(this.rangeInfoForm.zipCodeRange);
      if (this.tableData?.length === 0) {
        zipCodeRange.forEach((item) => {
          this.tableData.push({
            zipCodeCity: this.rangeInfoForm.city,
            zipCodeState: this.rangeInfoForm.state,
            range: item.startZip + '~' + item.endZip,
            startZip: item.startZip,
            endZip: item.endZip
          });
        });
      } else {
        this.$delete(this.tableData, this.tableListIndex);
        zipCodeRange.forEach((item) => {
          this.tableData.unshift({
            zipCodeCity: this.rangeInfoForm.city,
            zipCodeState: this.rangeInfoForm.state,
            range: item.startZip + '~' + item.endZip,
            startZip: item.startZip,
            endZip: item.endZip
          });
        });
      }
      // 关闭添加/编辑弹窗
      this.closeAdd();
    },
    // 关闭 新增/编辑 弹框
    closeAdd() {
      this.addCodeVisible = false;
      this.errorData = []; // 清空报错信息
      this.rangeInfoForm = {
        state: '',
        city: '',
        zipCodeRange: ''
      };
      this.editingRow = null;
      this.$nextTick(() => {
        if (this.$refs['rangeInfoFormRef']) {
          this.$refs['rangeInfoFormRef'].resetFields();
        }
      });
    },
    // 过滤非法字符
    zipCodeValueChange(val) {
      // 正则匹配：数字(\d)、~、,、换行(\n)，替换其他字符为空
      this.searchForm.params.zipCode = val.replace(/[^\d~,\n]/g, '');
    },
    getAddressState() {
      // level 0 州    1 城市   2 地区
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: item.nameEn
            };
          });
        }
      });
    },
    getAddressCity(val, type) {
      // 根据州及城市查询
      if (type === 1) {
        this.searchForm.params.cities = [];
        this.getCity(null, type);
      } else {
        this.rangeInfoForm.city = '';
        this.getCity(null, type);
      }
    },
    getCity(city = null, type) {
      const params = {
        pageNumber: 1,
        pageSize: 1000,
        params: {
          id: null,
          name: city,
          names: type === 1 ? this.searchForm.params.states : type === 2 ? [this.rangeInfoForm.state] : []
        }
      };
      optionSelectZipCodeManageCity(params, false).then((res) => {
        if (res.code === 200) {
          if (type === 1) {
            this.cityList = res.data.records;
          } else {
            this.cityList2 = res.data.records.map(item => {
              return {
                label: item.name,
                value: item.name,
                id: item.id
              };
            });
          }
        }
      });
    },

    // 过滤非法字符——新增/编辑
    handleZipCodeValueChange(val) {
      // 正则匹配：数字(\d)、~、,、换行(\n)，替换其他字符为空
      this.rangeInfoForm.zipCodeRange = val.replace(/[^\d~,\n]/g, '');
    },
    // 过滤空行
    zipCodeFil() {
      const currentValue = this.rangeInfoForm.zipCodeRange;
      if (!currentValue || currentValue.trim() === '') {
        this.rangeInfoForm.zipCodeRange = '';
        return;
      }
      const lines = currentValue.split('\n').flatMap(line => line.split(',')).filter(item => item.trim() !== '');
      const processedLines = lines.map(line => {
        line = line.trim();
        if (line.includes('~')) {
          const [start, end] = line.split('~').map(s => s.trim());
          if (!start || !end) {
            if (start && /^\d{8}$/.test(start)) {
              return start;
            } else if (end && /^\d{8}$/.test(end)) {
              return end;
            }
            return '';
          }
          if (start && end && /^\d{8}$/.test(start) && /^\d{8}$/.test(end)) {
            if (parseInt(start) > parseInt(end)) {
              this.$message.warning(this.$t('collectionCenter.zipCodeRangeSizePrompts'));
              return line;
            }
            return `${start}~${end}`;
          } else {
            this.$message.warning(this.$t('collectionCenter.format1'));
            return line;
          }
        } else {
          if (/^\d{8}$/.test(line)) {
            return line;
          } else {
            if (line !== '') {
              this.$message.warning(this.$t('collectionCenter.format1'));
            }
            return line;
          }
        }
      }).filter(part => part !== '');
      this.rangeInfoForm.zipCodeRange = processedLines.join(',');
    },
    readDialog(title, rangeVal, id, type) {
      // 处理查看状态
      this.businessType = type;
      this.codeTitle = title;
      this.isModify = false;
      this.siteId = id || 0;
      this.both();
      this.searchCode();
    },
    // 添加
    showDialog(val, type, rangeVal, id) {
      // (2, "小件揽收"),(3, "小件派送"),(4, "大件派送"),(5, "大件揽收");
      this.businessType = type;
      this.codeTitle = val;
      this.isModify = true;
      this.siteId = id || 0;
      this.both();
      if (rangeVal) {
        rangeVal.forEach(code => {
          let startZip = '';
          let endZip = '';
          if (code.range.includes('~')) {
            const [start, end] = code.range.split('~');
            startZip = start.trim();
            endZip = end.trim();
          } else {
            startZip = code.range;
            endZip = code.range;
          }
          this.tableData.push({
            ...code, // 包含原始项目的所有属性
            startZip,
            endZip
          });
        });
      }
    },
    both() {
      this.rangeInfoDialogVisible = true;
      // 获取州列表
      this.getAddressState();
      // 获取城市列表
      this.getAddressCity();
    },
    delRow(index) {
      const deletedRow = this.tableData[index];
      let zipCodeRangeToDelete;
      if (deletedRow.startZip === deletedRow.endZip) {
        zipCodeRangeToDelete = deletedRow.startZip;
      } else {
        zipCodeRangeToDelete = `${deletedRow.startZip}~${deletedRow.endZip}`;
      }
      // this.zipCodesToRemove = this.zipCodesToRemove.filter(item =>
      //   item.zipCodeRange !== zipCodeRangeToDelete
      // );
      // 根据当前业务类型过滤对应的移除列表
      if (this.businessType === 2) {
        this.zipCodesToRemove.cr = this.zipCodesToRemove.cr.filter(item =>
          item.zipCodeRange !== zipCodeRangeToDelete
        );
      } else if (this.businessType === 3) {
        this.zipCodesToRemove.dr = this.zipCodesToRemove.dr.filter(item =>
          item.zipCodeRange !== zipCodeRangeToDelete
        );
      } else if (this.businessType === 4) {
        this.zipCodesToRemove.bdr = this.zipCodesToRemove.bdr.filter(item =>
          item.zipCodeRange !== zipCodeRangeToDelete
        );
      }
      this.tableData.splice(index, 1);
    },
    // 删除全部
    deleteAll() {
      this.tableData = [];
      // this.zipCodesToRemove = [];
      // 根据当前业务类型清空对应的移除列表
      if (this.businessType === 2) {
        this.zipCodesToRemove.cr = [];
      } else if (this.businessType === 3) {
        this.zipCodesToRemove.dr = [];
      } else if (this.businessType === 4) {
        this.zipCodesToRemove.bdr = [];
      }
    },
    // 关闭抽屉弹框
    clearForm() {
      this.rangeInfoDialogVisible = false;
      this.searchForm = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          siteId: this.siteId,
          zipCode: '',
          states: [],
          cities: [],
          businessType: this.businessType
        }
      };
      this.tableData = [];
      // 清空当前业务类型的移除列表
      if (this.businessType === 2) {
        this.zipCodesToRemove.cr = [];
      } else if (this.businessType === 3) {
        this.zipCodesToRemove.dr = [];
      } else if (this.businessType === 4) {
        this.zipCodesToRemove.bdr = [];
      }
    },
    // 打开 添加/编辑 邮编弹框
    openAddForm() {
      this.rangeInfoForm = {
        state: '',
        city: '',
        zipCodeRange: ''
      };
      this.$nextTick(() => {
        if (this.$refs['rangeInfoFormRef']) {
          this.$refs['rangeInfoFormRef'].clearValidate();
        }
      });
      this.addCodeVisible = true;
      this.addEditTitle = this.$t('basicData.AddPostalCode');
    },
    // 提交保存
    async saveForm() {
      if (this.tableData && this.tableData.length) {
        const zipCodeRanges = this.tableData.map(item => {
          if (item.startZip === item.endZip) {
            return item.startZip;
          }
          return `${item.startZip}~${item.endZip}`;
        }).join(',');
        const tableData = this.tableData.map(item => {
          let zipCode = '';
          if (item.startZip === item.endZip) {
            zipCode = item.startZip;
          } else {
            zipCode = `${item.startZip}~${item.endZip}`;
          }
          return {
            zipCodeState: item.zipCodeState,
            zipCodeCity: item.zipCodeCity,
            range: zipCode
          };
        });
        // 根据业务类型返回对应的移除列表
        let specificZipCodesToRemove = [];
        if (this.businessType === 2) {
          specificZipCodesToRemove = this.zipCodesToRemove.cr;
        } else if (this.businessType === 3) {
          specificZipCodesToRemove = this.zipCodesToRemove.dr;
        } else if (this.businessType === 4) {
          specificZipCodesToRemove = this.zipCodesToRemove.bdr;
        }
        this.$emit('childrenData', zipCodeRanges, this.businessType, specificZipCodesToRemove, tableData);
        this.clearForm();
      } else {
        this.$emit('childrenData', [], this.businessType, [], []);
        this.clearForm();
      }
    },
    /**
     * 校验邮编范围值
     */
    validateZipCode(value) {
      const zipcodeSegments = value.split(',');
      const codeVal = []; // 存放所有邮编，去重检查
      let greaterThan = false; // 是否存在起始邮编大于结束邮编的情况
      for (const segment of zipcodeSegments) {
        if (segment.includes('~')) {
          // 处理区间邮编格式：如 1000000~22222222
          const [start, end] = segment.split('~');
          // 检查是否为8位数字
          if (!/^\d{8}$/.test(start) || !/^\d{8}$/.test(end)) {
            this.$message.warning(this.$t('collectionCenter.format1'));
            return false;
          }
          // 检查起始邮编不能大于结束邮编
          if (parseInt(start) > parseInt(end)) {
            greaterThan = true;
          }
          codeVal.push(start, end);
        } else {
          // 处理单个邮编格式：如 30000000
          if (!/^\d{8}$/.test(segment)) {
            this.$message.warning(this.$t('collectionCenter.format1'));
            return false;
          }
          codeVal.push(segment);
        }
      }
      const indexVal = this.useIndexOf(codeVal);
      if (new Set(codeVal).size !== codeVal.length) {
        this.$message.warning(
          this.$t('collectionCenter.noDuplicationAllowed') +
          '，' +
          this.$t('collectionCenter.repeat') +
          indexVal
        );
        return false;
      }
      if (greaterThan) {
        this.$message.warning(this.$t('collectionCenter.zipCodeRangeSizePrompts'));
        return false;
      }
      return true;
    },
    useIndexOf(Arr) {
      const len = Arr.length;
      const result = [];
      for (let i = 0; i < len; i++) {
        const curNum = Arr[i];
        // 遍历到Arr[i]时，若在这个索引i之后都没找到相同数字，则indexOf会返回-1，说明该数字不存在重复
        if (Arr.indexOf(curNum, i + 1) !== -1) {
          result.push(curNum);
        }
      }
      return Array.from(new Set(result));
    },
    /**
     * 校验邮编与表格重复值
     */
    checkDuplicateWithTableData(value) {
      const zipcodeSegments = value.split(',');
      const duplicateMessages = []; // 存放重复邮编，提示用
      for (const segment of zipcodeSegments) {
        if (segment.includes('~')) {
          const [start, end] = segment.split('~');
          for (const row of this.tableData) {
            let currentRowIsEditing = false;
            if (this.editingRow) {
              currentRowIsEditing =
                row.startZip === this.editingRow.startZip &&
                row.endZip === this.editingRow.endZip;
            }
            if (!currentRowIsEditing) {
              // 情况1: 输入的是范围，表格中是单个邮编（在范围内）
              if (row.startZip === row.endZip &&
                parseInt(row.startZip) >= parseInt(start) &&
                parseInt(row.startZip) <= parseInt(end)
              ) {
                duplicateMessages.push(`${row.startZip}`);
              } else if (row.startZip !== row.endZip) {
                // 情况2: 输入的是范围，表格中也是范围（有重叠）
                // 两个区间有重叠的条件：start <= row.endZip && end >= row.startZip
                if (parseInt(start) <= parseInt(row.endZip) && parseInt(end) >= parseInt(row.startZip)) {
                  duplicateMessages.push(`${row.startZip}~${row.endZip}`);
                }
              }
            }
          }
        } else {
          // 处理单个邮编格式：如 30000000
          for (const row of this.tableData) {
            let currentRowIsEditing = false;
            if (this.editingRow) {
              currentRowIsEditing =
                row.startZip === this.editingRow.startZip &&
                row.endZip === this.editingRow.endZip;
            }
            if (!currentRowIsEditing) {
              // 情况1: 输入的是单个邮编，表格中是范围（在范围内）
              if (row.startZip !== row.endZip &&
                parseInt(segment) >= parseInt(row.startZip) &&
                parseInt(segment) <= parseInt(row.endZip)
              ) {
                duplicateMessages.push(`${row.startZip}~${row.endZip}`);
              } else if (row.startZip === row.endZip && row.startZip === segment) {
                // 情况2: 输入的是单个邮编，表格中也是单个邮编（完全相同）
                duplicateMessages.push(`${segment}`);
              }
            }
          }
        }
      }

      if (duplicateMessages.length > 0) {
        const combinedMessage = duplicateMessages.join('，');
        this.$message.warning(`
          ${this.$t('collectionCenter.duplicateValuesExist')}：
          ${combinedMessage}
          ${this.$t('collectionCenter.pleaseReenter')}
        `);
        return false;
      }
      return true;
    }
  }
};
</script>

<style scoped>
.tip01 {
  background-color: #e6f1fe;
  color: #00A551;
  padding: 8px 10px;
  font-size: 14px;
  border-radius: 5px;
  margin-bottom: 10px;
}
.searchCodeClass >>> .el-form-item {
  margin-bottom: 0 !important;
}
.searchCodeClass {
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  padding-left: 10px;
  padding-bottom: 6px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
